// Bare landing page for the share subdomain. The app is single-purpose:
// only `/t/:token` is a real route. Anything else lands here.
export default function LandingRoute() {
  return (
    <div className="mx-auto flex min-h-dvh max-w-md flex-col items-center justify-center gap-6 px-6 py-12 text-center">
      <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-teal-500 text-white shadow-sm">
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
          <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
        </svg>
      </div>
      <div className="flex flex-col gap-2">
        <h1 className="text-2xl font-bold text-slate-900">Little Loop tutorials</h1>
        <p className="text-sm text-slate-600">
          You'll need a one-time link from a Little Loop guardian to view a tutorial here.
          Tap the link in your email to get started.
        </p>
      </div>
    </div>
  );
}
